<template>
    <section id="home-slide-jobs" class="p-5 container-fluid">
        <div class="my-5 flex justify-around">
            <h1>{{ gettext("A qui s'adresse Octolo") }}</h1>
        </div>

        <div class="py-5 block md:flex justify-around">
            <div @mouseover="showText(1)">
                <div class="job-image flex justify-around" :class="{active: isText(1)}">
                    <img class="rounded-circe" src="/static/img/DIRJUR.jpg" style="width: 140px; height: 140px;" />
                </div>
                <div class="title shrink-4" :class="{active: isText(1)}">{{ gettext("Direction Juridique") }}</div>
                <p class="mb-0 py-5 shrink-5 text-center md:hidden italic">
                    <span>«&nbsp;</span>
                    Une solution clef en main,
                    permettant de charger rapidement son actionnariat et de le gérer simplement.
                    Les salles de réunion virtuelles nous sont particulièrement utiles,
                    ainsi que l’automatisation des modèles de documents juridiques.
                    <span>&nbsp;»</span>
                </p>
            </div>
            <div @mouseover="showText(2)">
                <div class="job-image flex justify-around" :class="{active: isText(2)}">
                    <img class="rounded-circle" src="/static/img/AVOCAT.jpeg" style="width: 140px; height: 140px;" />
                </div>
                <div class="title shrink-4" :class="{active: isText(2)}">{{ gettext("Avocat") }}</div>
                <p class="mb-0 py-5 shrink-5 text-center md:hidden italic">
                    <span>«&nbsp;</span>
                    Notre compte cabinet nous permet de gérer à plusieurs gestionnaires et de manière très pratique les comptes de nos entreprises clientes,
                    tout en leur offrant un service moderne et intuitif.
                    Les échanges sont simplifiés et sécurisés.
                    Le simulateur d’augmentation de capital nous fait gagner un temps précieux.
                    <span>&nbsp;»</span>
                </p>
            </div>
            <div @mouseover="showText(3)">
                <div class="job-image flex justify-around" :class="{active: isText(3)}">
                    <img class="rounded-circle" src="/static/img/GROUPE.jpg" style="width: 140px; height: 140px;" />
                </div>
                <div class="title shrink-4" :class="{active: isText(3)}">{{ gettext("Groupe") }}</div>
                <p class="mb-0 py-5 shrink-5 text-center md:hidden italic">
                    <span>«&nbsp;</span>
                    Octolo permet de gérer les filiales depuis un seul compte et de regrouper de manière automatisée le secrétariat juridique.
                    La solution de visioconférence intégrée sur le site avec vote en live est très efficace et permet une gestion simplifiée des
                    assemblées générales de grande envergure.
                    <span>&nbsp;»</span>
                </p>
            </div>
            <div @mouseover="showText(4)">
                <div class="job-image flex justify-around" :class="{active: isText(4)}">
                    <img class="rounded-circle" src="/static/img/ASSOCIATION.png" style="width: 140px; height: 140px;" />
                </div>
                <div class="title shrink-4" :class="{active: isText(4)}">{{ gettext("Association") }}</div>
                <p class="mb-0 py-5 shrink-5 text-center md:hidden italic">
                    <span>«&nbsp;</span>
                    Avec Octolo, notre association tient à jour son registre de membres et
                    organise simplement son assemblée générale et ses comités.
                    Une solution flexible, accessible à tous.
                    <span>&nbsp;»</span>
                </p>
            </div>
        </div>

        <div class="hidden md:block">
            <p v-if="text==1" class="mx-5 mb-0 pb-5 shrink-2 text-center italic">
                <span>«&nbsp;</span>
                Une solution clef en main,
                permettant de charger rapidement son actionnariat et de le gérer simplement.
                Les salles de réunion virtuelles nous sont particulièrement utiles,
                ainsi que l’automatisation des modèles de documents juridiques.
                <span>&nbsp;»</span>
            </p>

            <p v-if="text==2" class="mx-5 mb-0 pb-5 shrink-2 text-center italic">
                <span>«&nbsp;</span>
                Notre compte cabinet nous permet de gérer à plusieurs gestionnaires et de manière très pratique les comptes de nos entreprises clientes,
                tout en leur offrant un service moderne et intuitif.
                Les échanges sont simplifiés et sécurisés.
                Le simulateur d’augmentation de capital nous fait gagner un temps précieux.
                <span>&nbsp;»</span>
            </p>

            <p v-if="text==3" class="mx-5 mb-0 p-5 shrink-2 text-center italic">
                <span>«&nbsp;</span>
                Octolo permet de gérer les filiales depuis un seul compte et de regrouper de manière automatisée le secrétariat juridique.
                La solution de visioconférence intégrée sur le site avec vote en live est très efficace et permet une gestion simplifiée des
                assemblées générales de grande envergure.
                <span>&nbsp;»</span>
            </p>

            <p v-if="text==4" class="mx-5 mb-0 p-5 shrink-2 text-center italic">
                <span>«&nbsp;</span>
                Avec Octolo, notre association tient à jour son registre de membres et
                organise simplement son assemblée générale et ses comités.
                Une solution flexible, accessible à tous.
                <span>&nbsp;»</span>
            </p>
        </div>
    </section>
</template>

<script>
export default {
    data(){return{
        text: 1,
    }},
    methods: {
        isText(text){
            return (this.text == text);
        },
        showText(text){
            this.text = text;
        }
    }
}
</script>

<style scoped lang="scss">
@import "@/assets/vars.scss";
#home-slide-jobs {
    > div > h1 { color: white; }
    background-color: $primary;

    > div > div {
        > .job-image {
            text-align: center;
            > img {
                border: 2px solid transparent;
                border-radius: 50%;
                overflow: hidden;
                padding: 2px;
            }
        }
        > .job-image:hover,
        > .job-image.active {

            > img {
                border: 2px solid $secondary;
            }
        }
        > .title {
            text-align: center;
            font-weight: bold;
            color: white;
        }
        > .title.active {
            color: $secondary;
        }
    }



    > div > p,
    > div > div > p {
        color: white;
        font-weight: bold;

        > span {
            color: $secondary;
        }
    }
}
</style>
